<template>
  <div>
    <GiftEditPage v-if="giftsList.length && giftsListCategories.length" />
    <div>
      <Drawer ref="drawer">
        <component v-if="component" :is="component"></component>
      </Drawer>
      <div class="empty-list-section">
        <div class="label-group" v-if="!giftsList.length">
          <div class="title-label">
            Você não possui nenhuma lista de presentes
          </div>
          <div class="subtitle-label">
            Selecione uma das opções a seguir para começar a criar a sua lista
          </div>
        </div>
        <div class="label-group" v-else>
          <div class="title-label">Você também pode incluir na sua lista</div>
        </div>
        <div class="empty-list-cards-section">
          <div
            class="empty-list-card"
            @click="openDrawer(giftCreateInfo, 'DrawerCreateGift')"
          >
            <div class="imgGroup"><img :src="createGiftImg" /></div>
            <div class="titleGroup">Criar um presente personalizado</div>
            <div class="subtitleGroup">
              Personalize do seu jeito. Insira imagens, valor e a descrição que
              deseja para cada produto.
            </div>
          </div>
          <div
            class="empty-list-card"
            @click="openDrawer(giftReadyInfo, 'DrawerReadyList')"
          >
            <div class="imgGroup"><img :src="readyListImg" /></div>
            <div class="titleGroup">Utilizar uma lista pronta</div>
            <div class="subtitleGroup">
              Destinos de lua de mel, produtos ou experiências? Temos diversas
              listas prontas para você não ter trabalho.
            </div>
          </div>
          <div
            class="empty-list-card"
            @click="openDrawer(giftCategoryInfo, 'DrawerGiftByCategory')"
          >
            <div class="imgGroup"><img :src="chooseGiftImg" /></div>
            <div class="titleGroup">Escolher presentes por categoria</div>
            <div class="subtitleGroup">
              Navegue pelo nosso catálogo de mais de 20.000 itens e selecione
              manualmente os que desejar.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import createGiftImg from '@/assets/img/create_gift.png'
import readyListImg from '@/assets/img/ready_list.png'
import chooseGiftImg from '@/assets/img/choose_gift.png'

import Drawer from '@/components/Drawer/Drawer.vue'
import DrawerGiftByCategory from './DrawerGiftByCategory.vue'
import DrawerCreateGift from './DrawerCreateGift.vue'
import DrawerReadyList from './DrawerReadyList.vue'
import GiftEditPage from './GiftEditPage.vue'

export default {
  components: {
    Drawer,
    DrawerGiftByCategory,
    DrawerReadyList,
    DrawerCreateGift,
    GiftEditPage,
  },
  data() {
    return {
      hasGifts: true,
      chooseGiftImg,
      readyListImg,
      createGiftImg,
      list: 0,
      component: 'DrawerCreateGift',
      giftCreateInfo: {
        title: 'Criar Presente',
        size: 'normal',
      },
      giftCategoryInfo: {
        title: 'Presentes por categoria',
        size: 'big',
      },
      giftReadyInfo: {
        title: 'Utilizar uma lista pronta',
        size: 'big',
      },
    }
  },

  computed: {
    ...mapGetters({
      giftsList: 'gifts/getGiftsList',
      giftsListCategories: 'gifts/getGiftsListCategories',
    }),
  },

  mounted() {
    this.fetchGiftsList()
  },

  methods: {
    ...mapActions({
      fetchGiftsList: 'gifts/fetchGiftsList',
    }),

    openDrawer(data, component) {
      this.component = component
      this.$refs.drawer.open(data)
    },
  },
}
</script>
<style lang="scss" scoped>
.empty-list-section {
  display: block;
  margin-top: 40px;
  margin-bottom: 40px;
  text-align: center;

  .label-group {
    display: inline-block;
    margin-left: 16px;
    margin-right: 16px;

    @media (max-width: 1024px) {
      display: block;
      text-align: center;
      justify-content: center;
    }

    .title-label {
      margin-top: 48px;
      font-size: 24px;
      color: $neutraldarkest;
      font-weight: 700;
    }

    .subtitle-label {
      margin-top: 8px;
      font-size: 18px;
      color: $neutraldarkest;
      font-weight: 400;
    }
  }

  .empty-list-cards-section {
    margin-top: 40px;
    display: flex;
    justify-content: center;

    @media (max-width: 1024px) {
      display: grid;
      gap: 24px;
    }

    .empty-list-card {
      width: 296px;
      min-height: 223px;
      margin: 0 24px;
      background: #ffffff;
      border: 1px solid #dde7f1;
      box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
      border-radius: 16px;
      display: block;
      padding-left: 24px;
      padding-right: 22px;
      padding-top: 24px;
      padding-bottom: 24px;
      cursor: pointer;
      @media (max-width: 1024px) {
        width: auto;
        margin: 0;
      }

      text-align: left;
      .imgGroup {
        margin-bottom: 20px;
        display: flex;
      }

      .titleGroup {
        color: $neutral;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 8px;
      }

      .subtitleGroup {
        color: $neutral;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
      }
    }

    .empty-list-card:hover {
      background-color: $neutrallightest;
    }
  }
}
</style>
